require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-155-raci-assigning-task-roles.json") })
        }
      }, "path---article-155-raci-assigning-task-roles");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-155-raci-assigning-task-roles!./.cache/json/article-155-raci-assigning-task-roles.json
// module id = 504
// module chunks = 231608221292675